import { useState } from "react";
import { useLocation } from "react-router-dom";
import DynamicMaster from "../../Components/DynamicMaster/DynamicMaster";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { ActionHandlerProvider } from "../../Components/ActionHandlerContext";


export default function FinancialYearMaster() {

  //const { userId,currentRoleId,permissionRecord } = useAuthStore();
   

    return (
        <>
        <ActionHandlerProvider>
          <DynamicMaster id="1" dashboardId="1" />
        </ActionHandlerProvider>
        </>
      );



}